<template>
    <VueDatePicker
        id="hrm-vue-date-picker"
        @closed="getValue"
        v-model="dateValue"
        autoApply
        :time-picker="vTimePicker"
        :range="vRange"
        :enable-time-picker="vEnableTime"
        :teleport="true"
        :month-picker="vMonthPicker"
        :year-picker="vYearPicker"
        :format="time ? '' : 'dd-MM-yyyy'"
        :placeholder="placeholder || 'Select Date'"
        :hide-input-icon="hideInputIcon"
    >
        <template v-if="vTrigger" #trigger>
            <p class="clickable-text" v-if="dateValue == null">
                <span
                    class="hrmInput mt-2 block w-full shadow-transparent text-base text-white dark:text-white bg-gray-200 dark:bg-gray-800 rounded-sm border border-gray-400 focus:border-amber-500 outline-0 focus:outline-0"
                >
                    <Icon icon="solar:calendar-outline" />
                </span>
            </p>
            <p class="text-xs text-white" v-else>{{ convertDate }}</p>
        </template>
        <template #input-icon>
            <Icon
                v-if="iconTypePicker && iconTypePicker == 'clock'"
                icon="solar:clock-circle-linear"
                width="18px"
                height="18px"
            />
            <Icon
                v-else
                icon="solar:calendar-minimalistic-linear"
                width="18px"
                height="18px"
            />
        </template>
        <template #clear-icon="{ clear }">
            <div class="mr-3" @click="clearDate(clear)">
                <Icon icon="maki:cross" width="12" height="12" />
            </div>
        </template>
    </VueDatePicker>
</template>
<script>
import { Icon } from "@iconify/vue";

import VueDatePicker from "@vuepic/vue-datepicker";
export default {
    name: "DatePicker",
    components: {
        VueDatePicker,
        Icon,
    },
    data() {
        return {
            dateValue: null,
            convertDate: null,
            timeOutData: null
        };
    },
    props: {
        vTrigger: {
            type: Boolean,
            default: false,
        },
        vRange: {
            type: Boolean,
            default: false,
        },
        vTimePicker: {
            type: Boolean,
            default: false,
        },
        vYearPicker: {
            type: Boolean,
            default: false,
        },
        vMonthPicker: {
            type: Boolean,
            default: false,
        },
        vEnableTime: {
            type: Boolean,
            default: false,
        },
        vNewDate: {
            type: [String, Date],
            default: "",
        },
        dateData: {
            type: [String, Date, Array, Number],
            default: "",
        },
        time: {
            type: Boolean,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        format_header: {
            type: String,
            default: "",
        },
        field: {
            type: String,
            default: "",
        },
        modelValue: {
            type: [String, Date, Array, Number],
            default: "",
        },
        iconTypePicker: {
            type: String,
            default: "",
        },
        hideInputIcon: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getValue() {
            if (this.time && this.format_header) {
                this.$emit("submitTime", this.dateValue, this.field);
            } else {
                this.$emit("submitDate", this.dateValue, this.field);
            }
        },
        clearDate(clear) {
            clear();
            this.$emit("submitDate", this.dateValue, this.field);
        },
        clearValue() {
            this.dateValue = null;
            this.$emit("submitDate", this.dateValue, this.field);
        },
        parseTime(timeString) {
            if (!timeString || typeof timeString !== "string") return null;

            const parts = timeString.split(":").map(Number);
            return { hours: parts[0], minutes: parts[1], seconds: parts[2] };
        },
    },
    created() {
        if (this.vYearPicker && !this.dateData) {
            this.dateValue = new Date().getFullYear();
            return;
        }

        clearTimeout(this.timeOutData)
        this.timeOutData = setTimeout(() => {
            if (this.time) {
                if (this.dateData) {
                    this.dateValue = this.dateData;
                }
            } else if (this.vNewDate && this.dateData == null) {
                this.dateValue = new Date();
            } else {
                this.dateValue = this.dateData ? this.dateData : null;
            }
        }, 1000);
    },
    unmounted() {
        clearTimeout(this.timeOutData)
    }
};
</script>
